import { createSelector } from 'reselect';

import { initialState } from './reducer';

const selectClient = (state) => state.client || initialState;

const selectProfile = createSelector(selectClient, (clientState) => clientState.profile);
const selectWallet = createSelector(selectClient, (clientState) => clientState.wallet);

export {
  selectProfile,
  selectWallet
};
